import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
var state = {
  FCMToken: null,
  intents: [],
  snackbar: {
    message: '',
    show: false,
    timeout: 500,
    important: false,
    href: null,
    isLoading: false,
    icon: '',
    iconColor: '',
    color: '',
    light: false,
    width: null
  },
  cachedResult: null,
  errorMessage: null,
  newMessage: null,
  testMessage: null,
  isEditingMode: false,
  windowWidth: window.innerWidth
};
var mutations = {
  setwindowWidth: function setwindowWidth(state, payload) {
    state.windowWidth = payload;
  },
  showSnackbar: function showSnackbar(state, payload) {
    if (state.snackbar.show) {
      state.snackbar.show = false;
    }
    setTimeout(function () {
      if (typeof payload.message == 'string' || typeof payload == 'string') {
        state.snackbar.message = payload.message ? payload.message : payload;
        state.snackbar.href = null;
        state.snackbar.timeout = 500;
        state.snackbar.important = false;
        state.snackbar.show = true;
        state.snackbar.isLoading = payload.isLoading;
        state.snackbar.icon = payload.icon;
        state.snackbar.iconColor = payload.iconColor;
        state.snackbar.color = payload.color;
        state.snackbar.light = payload.light;
        state.snackbar.width = payload.width;
      } else {
        state.snackbar.message = payload.message;
        state.snackbar.href = payload.href;
        state.snackbar.show = true;
        state.snackbar.important = payload.important ? payload.important : false;
      }
    }, 500);
  },
  setCacheLastResult: function setCacheLastResult(state, payload) {
    state.cachedResult = payload;
  },
  setErrorMessage: function setErrorMessage(state, payload) {
    state.errorMessage = payload;
  },
  setEventNewMessage: function setEventNewMessage(state, payload) {
    state.newMessage = payload;
    setTimeout(function () {
      state.newMessage = null;
    }, 100);
  },
  setIsEditingMode: function setIsEditingMode(state, payload) {
    state.isEditingMode = payload;
  },
  handleTestMessage: function handleTestMessage(state, payload) {
    state.testMessage = payload;
    setTimeout(function () {
      state.testMessage = null;
    }, 100);
  }
};
var getters = {
  getwindowWidth: function getwindowWidth(state) {
    return state.windowWidth;
  },
  getFCMToken: function getFCMToken(state) {
    return state.FCMToken;
  },
  getIntents: function getIntents(state) {
    return state.intents;
  },
  getSnackbarInstance: function getSnackbarInstance(state) {
    return state.snackbar;
  },
  getErrorMessage: function getErrorMessage(state) {
    return state.errorMessage;
  },
  getCachedResult: function getCachedResult(state) {
    return state.cachedResult;
  },
  getEventNewMessage: function getEventNewMessage(state) {
    return state.newMessage;
  },
  getEventTestMessage: function getEventTestMessage(state) {
    return state.testMessage;
  },
  getIsEditingMode: function getIsEditingMode(state) {
    return state.isEditingMode;
  },
  appVersion: function appVersion(state) {
    return state.packageVersion;
  }
};
var actions = {
  detectWindowWidth: function detectWindowWidth(_ref) {
    var commit = _ref.commit;
    window.addEventListener('resize', function () {
      commit('setwindowWidth', window.innerWidth);
    });
  },
  verifyIfHasDisableds: function verifyIfHasDisableds(_ref2, list) {
    var commit = _ref2.commit;
    var disabledList = list.filter(function (item) {
      return item.active == false;
    });
  }
};

// const actions = {}

export default {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  namespaced: true
};